module.exports = __webpack_public_path__ + "static/media/GT13_AT_Room-Locations.3308e171.csv";